import React, { FC, RefObject } from 'react';
import Button from '@lt/components/components/ButtonTs';
import styled from 'styled-components';

export const ApplyButton: FC<
  React.HTMLProps<HTMLButtonElement> & {
    buttonRef: RefObject<HTMLButtonElement>;
  }
> = ({ children, onClick, disabled, buttonRef }) => (
  <StyledButton disabled={disabled} size="large" offHover onClick={onClick} buttonRef={buttonRef}>
    {children}
  </StyledButton>
);

const StyledButton = styled(Button)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: inherit;
    margin: 0 auto;
    background-color: #007aff;
    border: none;
    color: #fff;
    font-size: 14px;
    transition: 0.3s;
    padding: 8px 16px;

    &:hover {
      transform: scale(1.02);
    }
  }
`;
